import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { Familia, Produto } from '../models/produto';
import { ProdutoClassificacao } from '../models/produto-classificacao';

@Injectable({
  providedIn: 'root'
})
export class ProdutoService {
  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) {}

  consultarOfertasKit() {
    return this.http.get<any>(globals.apiUrl + '/api/Produto/ListaOfertasKit');
  }

  consultarComPaginacao(
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    descri,
    codBarra,
    ativo,
    familia,
    estoqueReserva,
    potencia,
    marca,
    fase,
    potDe,
    potAte,
    idFornecedorPainel?,
    trazerMenorPrecoFornecedor?,
    idProduto?,
    marcaPainel?,
    marcaInversor?,
    telhado?,
    ordenacaoKit?,
    avulso?,
    microInversor?,
    tipoInv?,
    distribuidor?,
    telaKitPronto?,
    idCliente?,
    telaProdutos?,
    codErp?,
    referencia?,
    statusCDSelecionado?,
    menuOrigem?,
    categoria?,
    origemGi?,
    idLoja?
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('descri', descri ? descri : '')
      .set('codBarra', codBarra ? codBarra : '')
      .set('ativo', ativo ? ativo : '')
      .set('familia', familia !== undefined && familia !== null && familia !== -1 ? familia : '')
      .set('estoqueReserva', estoqueReserva)
      .set('potencia', potencia !== undefined && potencia !== null ? potencia : '')
      .set('marca', marca !== undefined && marca !== null ? marca : '')
      .set('fase', fase !== undefined && fase !== null ? fase : '')
      .set('potDe', potDe !== undefined && potDe !== null ? potDe : '')
      .set('potAte', potAte !== undefined && potAte !== null ? potAte : '')
      .set(
        'idFornecedorPainel',
        idFornecedorPainel !== undefined && idFornecedorPainel !== null ? idFornecedorPainel : ''
      )
      .set('idProduto', idProduto !== undefined && idProduto !== null ? idProduto : '')
      .set(
        'trazerMenorPrecoFornecedor',
        trazerMenorPrecoFornecedor !== undefined && trazerMenorPrecoFornecedor !== null
          ? trazerMenorPrecoFornecedor
          : ''
      )
      .set('marcaPainel', marcaPainel !== undefined && marcaPainel !== null ? marcaPainel : '')
      .set('marcaInversor', marcaInversor !== undefined && marcaInversor !== null ? marcaInversor : '')
      .set('telhado', telhado !== undefined && telhado !== null ? telhado : '')
      .set('ordenacaoKit', ordenacaoKit !== undefined && ordenacaoKit !== null ? ordenacaoKit : '')
      .set('avulso', avulso !== undefined && avulso !== null ? avulso : '')
      .set('microInversor', microInversor !== undefined && microInversor !== null ? microInversor : '')
      .set('tipoInv', tipoInv !== undefined && tipoInv !== null ? tipoInv : '')
      .set('distribuidor', distribuidor !== undefined && distribuidor !== null ? distribuidor : false)
      .set('telaKitPronto', telaKitPronto !== undefined && telaKitPronto !== null ? telaKitPronto : false)
      .set('idCliente', idCliente !== undefined && idCliente !== null ? idCliente : '')
      .set('telaProdutos', telaProdutos !== undefined && telaProdutos !== null ? telaProdutos : false)
      .set('codErp', codErp !== undefined && codErp !== null ? codErp : '')
      .set('referencia', referencia !== undefined && referencia !== null ? referencia : '')
      .set('statusCD', statusCDSelecionado ? statusCDSelecionado : '')
      .set('menuOrigem', menuOrigem !== undefined && menuOrigem !== null ? menuOrigem : '')
      .set('categoria', categoria !== undefined && categoria !== null ? categoria : '')
      .set('origemGi', origemGi !== undefined && origemGi !== null && !isNaN(origemGi) ? origemGi : '')
      .set('idLoja', idLoja !== undefined && idLoja !== null ? idLoja : '');

    return this.http.get<any>(globals.apiUrl + '/api/Produto/ListaPag', {
      params: parametros
    });
  }

  consultarKitFechadoComPaginacao(
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    descri,
    codBarra,
    ativo,
    familia,
    estoqueReserva,
    potencia,
    marca,
    fase,
    potDe,
    potAte,
    idFornecedorPainel?,
    trazerMenorPrecoFornecedor?,
    idProduto?,
    marcaPainel?,
    marcaInversor?,
    telhado?,
    ordenacaoKit?,
    avulso?,
    microInversor?,
    tipoInv?,
    distribuidor?,
    telaKitPronto?,
    idCliente?,
    menuOrigem?
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('descri', descri ? descri : '')
      .set('codBarra', codBarra ? codBarra : '')
      .set('ativo', ativo ? ativo : '')
      .set('familia', familia !== undefined && familia !== null && familia !== -1 ? familia : '')
      .set('estoqueReserva', estoqueReserva)
      .set('potencia', potencia !== undefined && potencia !== null ? potencia : '')
      .set('marca', marca !== undefined && marca !== null ? marca : '')
      .set('fase', fase !== undefined && fase !== null ? fase : '')
      .set('potDe', potDe !== undefined && potDe !== null ? potDe : '')
      .set('potAte', potAte !== undefined && potAte !== null ? potAte : '')
      .set(
        'idFornecedorPainel',
        idFornecedorPainel !== undefined && idFornecedorPainel !== null ? idFornecedorPainel : ''
      )
      .set('idProduto', idProduto !== undefined && idProduto !== null ? idProduto : '')
      .set(
        'trazerMenorPrecoFornecedor',
        trazerMenorPrecoFornecedor !== undefined && trazerMenorPrecoFornecedor !== null
          ? trazerMenorPrecoFornecedor
          : ''
      )
      .set('marcaPainel', marcaPainel !== undefined && marcaPainel !== null ? marcaPainel : '')
      .set('marcaInversor', marcaInversor !== undefined && marcaInversor !== null ? marcaInversor : '')
      .set('telhado', telhado !== undefined && telhado !== null ? telhado : '')
      .set('ordenacaoKit', ordenacaoKit !== undefined && ordenacaoKit !== null ? ordenacaoKit : '')
      .set('avulso', avulso !== undefined && avulso !== null ? avulso : '')
      .set('microInversor', microInversor !== undefined && microInversor !== null ? microInversor : '')
      .set('tipoInv', tipoInv !== undefined && tipoInv !== null ? tipoInv : '')
      .set('distribuidor', distribuidor !== undefined && distribuidor !== null ? distribuidor : false)
      .set('telaKitPronto', telaKitPronto !== undefined && telaKitPronto !== null ? telaKitPronto : false)
      .set('idCliente', idCliente !== undefined && idCliente !== null ? idCliente : '')
      .set('menuOrigem', menuOrigem !== undefined && menuOrigem !== null ? menuOrigem : '');

    return this.http.get<any>(globals.apiUrl + '/api/Produto/ListaKitFechadoPag', {
      params: parametros
    });
  }

  trocarCD(ids, estoqueReserva, idFornecedorPainel, familia) {
    let parametros = new HttpParams()
      .set('ids', ids)
      .set('estoqueReserva', estoqueReserva)
      .set(
        'idFornecedorPainel',
        idFornecedorPainel !== undefined && idFornecedorPainel !== null ? idFornecedorPainel : ''
      )
      .set('familia', familia !== undefined && familia !== null && familia !== -1 ? familia : '');

    return this.http.get<any>(globals.apiUrl + '/api/Produto/TrocarCD', {
      params: parametros
    });
  }

  consultarPorId(idProduto, buscarValoresFornecedor?, idMarcaInversor?, idFornecedorPainel?, buscarReserva?) {
    let parametros = new HttpParams().set('idProduto', idProduto);

    if (buscarValoresFornecedor !== null && buscarValoresFornecedor !== undefined) {
      parametros = parametros.set('buscarValoresFornecedor', buscarValoresFornecedor);
    }

    if (idMarcaInversor !== null && idMarcaInversor !== undefined) {
      parametros = parametros.set('idMarcaInversor', idMarcaInversor);
    }

    if (idFornecedorPainel !== null && idFornecedorPainel !== undefined) {
      parametros = parametros.set('idFornecedorPainel', idFornecedorPainel);
    }

    if (buscarReserva !== null && buscarReserva !== undefined) {
      parametros = parametros.set('buscarReserva', buscarReserva);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Produto/Buscar', {
      params: parametros
    });
  }

  consultarPrecosFornecedores(idProduto) {
    let parametros = new HttpParams().set('idProduto', idProduto);

    return this.http.get<any>(globals.apiUrl + '/api/Produto/BuscarPrecosFornecedores', {
      params: parametros
    });
  }

  salvarValoresFornecedor(valores) {
    return this.http.post(globals.apiUrl + '/api/Produto/SalvarValoresFornecedor', valores);
  }

  consultarDescontos(idProduto) {
    let parametros = new HttpParams().set('idProduto', idProduto);

    return this.http.get<any>(globals.apiUrl + '/api/Produto/BuscarDescontos', {
      params: parametros
    });
  }

  ativar(id) {
    return this.http.get(globals.apiUrl + '/api/Produto/Ativar', { params: new HttpParams().set('id', id) });
  }

  bloquear(id) {
    return this.http.delete(globals.apiUrl + '/api/Produto/Bloquear', { params: new HttpParams().set('id', id) });
  }

  inativar(id) {
    return this.http.delete(globals.apiUrl + '/api/Produto/Inativar', { params: new HttpParams().set('id', id) });
  }

  consultarFamilias() {
    return this.http.get<Familia[]>(globals.apiUrl + '/api/Produto/Familias');
  }

  buscarStringboxes() {
    return this.http.get<Produto[]>(globals.apiUrl + '/api/Produto/BuscarStringboxes');
  }

  salvar(produto) {
    return this.http.post(globals.apiUrl + '/api/Produto/Salvar', produto);
  }

  buscarPaineis(idFornecedor?) {
    return this.http.get<any>(globals.apiUrl + '/api/Produto/BuscarPaineis', {
      params: new HttpParams().set(
        'idFornecedor',
        idFornecedor === undefined || idFornecedor === null ? '' : idFornecedor
      )
    });
  }

  listarPorFamilia(familia, distribuidor?) {
    return this.http.get<any>(globals.apiUrl + '/api/Produto/ListarPorFamilia', {
      params: new HttpParams()
        .set('familia', familia)
        .set('distribuidor', distribuidor === null || distribuidor === undefined ? 'false' : distribuidor)
    });
  }
  importar(dados, kits) {
    return this.http.post(globals.apiUrl + '/api/Produto/Importar' + (kits ? 'Kits' : 'Produtos') + 'Erp', dados);
  }

  atualizarProdutos(dados) {
    return this.http.post(globals.apiUrl + '/api/Produto/AtualizarProdutos', dados);
  }

  importarProdutos(dados) {
    return this.http.post(globals.apiUrl + '/api/Produto/ImportarProdutos', dados);
  }

  importarEstoque(dados, idFornecedor?) {
    if (idFornecedor === null || idFornecedor === undefined) {
      return this.http.post(globals.apiUrl + '/api/Produto/ImportarEstoque', dados);
    } else {
      return this.http.post(globals.apiUrl + '/api/Produto/ImportarEstoqueFornecedor', dados, {
        params: new HttpParams().set('idFornecedor', idFornecedor)
      });
    }
  }

  exportarEstoque(situacao: string, idFornecedor?: number, idFamilia?: number, idCategoria?: number) {
    const endPoint =
      idFornecedor === null || idFornecedor === undefined
        ? '/api/Produto/ExportarEstoque'
        : '/api/Produto/ExportarEstoqueFornecedor';

    let parametros = new HttpParams().set('situacao', situacao);

    if (idFornecedor !== null && idFornecedor !== undefined) {
      parametros = parametros.set('idFornecedor', idFornecedor.toString());
    }

    if (idFamilia !== null && idFamilia !== undefined) {
      parametros = parametros.set('idFamilia', idFamilia.toString());
    }

    if (idCategoria !== null && idCategoria !== undefined) {
      parametros = parametros.set('idCategoria', idCategoria.toString());
    }

    return this.http.get(`${globals.apiUrl}${endPoint}`, { responseType: 'blob', params: parametros });
  }

  exportarValores(situacao, idFornecedor?, idFamilia?, idCategoria?, situacaoForn?) {
    const endPoint =
      idFornecedor === null || idFornecedor === undefined
        ? '/api/Produto/ExportarValores'
        : '/api/Produto/ExportarValoresFornecedor';

    let parametros = new HttpParams().set('situacao', situacao);

    if (idFornecedor !== null && idFornecedor !== undefined) {
      parametros = parametros.set('idFornecedor', idFornecedor.toString());
    }

    if (idFamilia !== null && idFamilia !== undefined) {
      parametros = parametros.set('idFamilia', idFamilia.toString());
    }

    if (idCategoria !== null && idCategoria !== undefined) {
      parametros = parametros.set('idCategoria', idCategoria.toString());
    }

    if (situacaoForn !== null && situacaoForn !== undefined) {
      parametros = parametros.set('situacaoForn', situacaoForn);
    }

    return this.http.get(`${globals.apiUrl}${endPoint}`, { responseType: 'blob', params: parametros });
  }

  exportarProdutosEstoque(
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    descri,
    codBarra,
    ativo,
    familia,
    estoqueReserva,
    potencia,
    marca,
    fase,
    potDe,
    potAte,
    idFornecedorPainel?,
    trazerMenorPrecoFornecedor?,
    idProduto?,
    marcaPainel?,
    marcaInversor?,
    telhado?,
    ordenacaoKit?,
    avulso?,
    microInversor?,
    tipoInv?,
    distribuidor?,
    telaKitPronto?,
    idCliente?,
    codErp?,
    referencia?,
    statusCD?,
    idCategoria?
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('descri', descri ? descri : '')
      .set('codBarra', codBarra ? codBarra : '')
      .set('ativo', ativo ? ativo : '')
      .set('familia', familia !== undefined && familia !== null && familia !== -1 ? familia : '')
      .set('estoqueReserva', estoqueReserva)
      .set('potencia', potencia !== undefined && potencia !== null ? potencia : '')
      .set('marca', marca !== undefined && marca !== null ? marca : '')
      .set('fase', fase !== undefined && fase !== null ? fase : '')
      .set('potDe', potDe !== undefined && potDe !== null ? potDe : '')
      .set('potAte', potAte !== undefined && potAte !== null ? potAte : '')
      .set(
        'idFornecedorPainel',
        idFornecedorPainel !== undefined && idFornecedorPainel !== null ? idFornecedorPainel : ''
      )
      .set('idProduto', idProduto !== undefined && idProduto !== null ? idProduto : '')
      .set(
        'trazerMenorPrecoFornecedor',
        trazerMenorPrecoFornecedor !== undefined && trazerMenorPrecoFornecedor !== null
          ? trazerMenorPrecoFornecedor
          : ''
      )
      .set('marcaPainel', marcaPainel !== undefined && marcaPainel !== null ? marcaPainel : '')
      .set('marcaInversor', marcaInversor !== undefined && marcaInversor !== null ? marcaInversor : '')
      .set('telhado', telhado !== undefined && telhado !== null ? telhado : '')
      .set('ordenacaoKit', ordenacaoKit !== undefined && ordenacaoKit !== null ? ordenacaoKit : '')
      .set('avulso', avulso !== undefined && avulso !== null ? avulso : '')
      .set('microInversor', microInversor !== undefined && microInversor !== null ? microInversor : '')
      .set('tipoInv', tipoInv !== undefined && tipoInv !== null ? tipoInv : '')
      .set('distribuidor', distribuidor !== undefined && distribuidor !== null ? distribuidor : false)
      .set('telaKitPronto', telaKitPronto !== undefined && telaKitPronto !== null ? telaKitPronto : false)
      .set('idCliente', idCliente !== undefined && idCliente !== null ? idCliente : '')
      .set('codErp', codErp !== undefined && codErp !== null ? codErp : '')
      .set('referencia', referencia !== undefined && referencia !== null ? referencia : '')
      .set('statusCD', statusCD ? statusCD : '')
      .set('idCategoria', idCategoria !== null && idCategoria !== undefined ? idCategoria.toString() : '');

    return this.http.get(globals.apiUrl + '/api/Produto/ExportarProdutosEstoque', {
      responseType: 'blob',
      params: parametros
    });
  }

  importarValores(dados, idFornecedor?) {
    if (idFornecedor === null || idFornecedor === undefined) {
      return this.http.post(globals.apiUrl + '/api/Produto/ImportarValores', dados);
    } else {
      return this.http.post(globals.apiUrl + '/api/Produto/ImportarValoresFornecedor', dados, {
        params: new HttpParams().set('idFornecedor', idFornecedor)
      });
    }
  }

  baixarModelo() {
    return this.http.get(globals.apiUrl + '/api/Produto/BaixarModelo', { responseType: 'blob' });
  }

  baixarModeloKit() {
    return this.http.get(globals.apiUrl + '/api/Produto/BaixarModeloKit', { responseType: 'blob' });
  }

  baixarModeloProdutos() {
    return this.http.get(globals.apiUrl + '/api/Produto/BaixarModeloProdutos', { responseType: 'blob' });
  }

  exportarProdutos() {
    return this.http.get(globals.apiUrl + '/api/Produto/ExportarProdutos', { responseType: 'blob' });
  }

  consultarFotoProdutoPorId(idProduto) {
    let parametros = new HttpParams().set('idProduto', idProduto);

    return this.http.get(globals.apiUrl + '/api/Produto/BuscarFoto', {
      params: parametros,
      responseType: 'blob'
    });
  }

  consultarImagemProdutoPorId(idProduto) {
    const parametros = new HttpParams().set('idProduto', idProduto);

    return this.http.get<any>(globals.apiUrl + '/api/Produto/BuscarImagem', { params: parametros });
  }

  consultarPrecosFornecedoresPorIds(ids, idFornecedor) {
    return this.http.post<any>(globals.apiUrl + '/api/Produto/BuscarPrecosFornecedoresPorIds', { ids, idFornecedor });
  }

  consultarFornecedorComPrecoMaisBarato(ids, idFornecedor, total, precoAvulso) {
    return this.http.post<any>(globals.apiUrl + '/api/Produto/FornecedorComPrecoMaisBarato', {
      ids,
      idFornecedor,
      total,
      precoAvulso
    });
  }

  // AtualizarRegraMicroInversor
  atualizarRegraMicroInversor(idProduto, regra) {
    return this.http.post<any>(globals.apiUrl + '/api/Produto/AtualizarRegraMicroInversor', { idProduto, regra });
  }

  possuiMicroInversorConfigurado() {
    return this.http.get<any>(globals.apiUrl + '/api/Produto/PossuiMicroInversorConfigurado');
  }

  consultarSeExisteProtudoCodErp(codErp) {
    let parametros = new HttpParams().set('codErp', codErp);

    return this.http.get<any>(globals.apiUrl + '/api/Produto/ExisteProdutoCodErp', {
      params: parametros
    });
  }

  enviarAvisoEstoqueMinimo(dados) {
    return this.http.post<any>(globals.apiUrl + '/api/Produto/enviarAvisoEstoqueMinimo', dados);
  }

  testeMarketPlace() {
    return this.http.get<any>(globals.apiUrl + '/marketPlace/teste');
  }

  consultarPedidosDaReserva(idProduto, idFornecedor) {
    let parametros = new HttpParams().set('idProduto', idProduto);

    if (idFornecedor !== null && idFornecedor !== undefined) {
      parametros = parametros.set('idFornecedor', idFornecedor);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Produto/PedidosDaReserva', {
      params: parametros
    });
  }

  atualizarValoresFornecedor(dados) {
    return this.http.post<any>(globals.apiUrl + '/api/Produto/AtualizarValoresFornecedor', dados);
  }

  exportarPedidosDaReserva(idProduto, idFornecedor) {
    let parametros = new HttpParams().set('idProduto', idProduto);

    if (idFornecedor !== null && idFornecedor !== undefined) {
      parametros = parametros.set('idFornecedor', idFornecedor);
    }

    return this.http.get(globals.apiUrl + '/api/Produto/ExportarPedidosDaReserva', {
      responseType: 'blob',
      params: parametros
    });
  }

  buscarClassificacaoPreenchida(idProduto) {
    let parametros = new HttpParams().set('idProduto', idProduto);

    return this.http.get<ProdutoClassificacao[]>(globals.apiUrl + '/api/Produto/BuscarClassificacaoPreenchida', {
      params: parametros
    });
  }

  consultarHistoricoDoPreco(idProduto, periodo, idFornecedor?) {
    let parametros = new HttpParams().set('idProduto', idProduto).set('periodo', periodo);

    if (idFornecedor !== null && idFornecedor !== undefined) {
      parametros = parametros.set('idFornecedor', idFornecedor);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Produto/HistoricoDoPreco', {
      params: parametros
    });
  }

  consultarPossuiOrcamentoPedido(idProduto) {
    let parametros = new HttpParams().set('idProduto', idProduto);

    return this.http.get<any>(globals.apiUrl + '/api/Produto/PossuiOrcamentoPedido', {
      params: parametros
    });
  }

  buscarEstoque(idsProdutos, idFornecedor, idCupom) {
    return this.http.post<any>(globals.apiUrl + '/api/Produto/BuscarEstoque', { idsProdutos, idFornecedor, idCupom });
  }

  alterarSituacaoProdutoFornecedor(idProduto, idFornecedor, situacao) {
    return this.http.get(globals.apiUrl + '/api/Produto/AlterarSituacaoProdutoFornecedor', {
      params: new HttpParams().set('idProduto', idProduto).set('idFornecedor', idFornecedor).set('situacao', situacao)
    });
  }

  buscarComposicoes(idsKits, idFornecedor, idCupom) {
    return this.http.post<any>(globals.apiUrl + '/api/Produto/ListarComposicoes', { idsKits, idFornecedor, idCupom });
  }

  buscarClassificacoes(selecionados, idCategoria) {
    return this.http.post<any>(globals.apiUrl + '/api/Produto/BuscarClassificacoes', { selecionados, idCategoria });
  }

  consultarHistoricoDoEstoque(idProduto, idFornecedor?) {
    let parametros = new HttpParams().set('idProduto', idProduto);

    if (idFornecedor !== null && idFornecedor !== undefined) {
      parametros = parametros.set('idFornecedor', idFornecedor);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Produto/BuscarHistoricoEstoque', {
      params: parametros
    });
  }

  consultarProdutosLoja(filtros) {
    return this.http.post<any>(globals.apiUrl + '/api/Produto/ListaProdutosPag', filtros);
  }

  consultarProdutosBloqueadosPorIdCupom(idcupom) {
    return this.http.get<any>(globals.apiUrl + '/api/Produto/BuscarProdutosBloqueadosPorCupomId', {
      params: new HttpParams().set('idcupom', idcupom)
    });
  }
}
